export const SEGMENTS = {
    ABOUT_CGC: 'ABOUT_CGC',
    ABOUT_IMSME: 'ABOUT_IMSME',
    HOW_TO_USE_IMSME: 'HOW_TO_USE_IMSME',
    PRODUCT_INFO: 'PRODUCT_INFO',
    MYKNP: 'MYKNP',
    CGC: 'CGC',
}

export const SEGMENTS_DATA = Object.keys(SEGMENTS).map((seg, index) => ({
    index,
    value: seg
}))